import React, { createContext, useCallback, useContext, useEffect, useState } from "react";
import { authLogout, exchangeAuthSession, getAuthMe } from "../lib/api";

const AuthContext = createContext({
    user: null,
    loading: true,
    login: () => {},
    logout: async () => {},
    refresh: async () => {},
});

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const [loading, setLoading] = useState(true);

    const refresh = useCallback(async () => {
        try {
            const me = await getAuthMe();
            setUser(me);
            return me;
        } catch (e) {
            // 401 / network — treat as logged out (expected for fresh visitors)
            if (e?.response?.status !== 401) {
                console.warn("Auth refresh failed:", e?.message);
            }
            setUser(null);
            return null;
        }
    }, []);

    useEffect(() => {
        // CRITICAL: If returning from OAuth callback, skip the /me check —
        // AuthCallback will handle session_id exchange first.
        if (window.location.hash?.includes("session_id=")) {
            setLoading(false);
            return;
        }
        refresh().finally(() => setLoading(false));
    }, [refresh]);

    const login = useCallback(() => {
        // REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
        const redirectUrl = window.location.origin + "/";
        window.location.href = `https://auth.emergentagent.com/?redirect=${encodeURIComponent(redirectUrl)}`;
    }, []);

    const logout = useCallback(async () => {
        try {
            await authLogout();
        } catch (e) {
            console.warn("Logout request failed (clearing local state anyway):", e?.message);
        }
        setUser(null);
    }, []);

    return (
        <AuthContext.Provider value={{ user, loading, login, logout, refresh, exchangeAuthSession, setUser }}>
            {children}
        </AuthContext.Provider>
    );
}

export function useAuth() {
    return useContext(AuthContext);
}
